import React, { useMemo } from 'react';
import useFetchData from '../../../../app/api/hooks/useFetchData';

import useWidgetByType from '../../hooks/useWidgetByType';
import { MetricData, MetricWidgetProps, IUseWidgetByType, MetricTypeEnum } from '../../Metrics.model';
import { Endpoints } from '../../../../app/api/model/API.endpoints';

const MetricWidget: React.FC<MetricWidgetProps> = (props: MetricWidgetProps) => {
  const { isSuccess: cacheReady, isFetching: precacheFetching } = useFetchData<MetricData>({
    endpoint: Endpoints.PRECACHE_SESSIONS,
    options: { keepPreviousData: false },
    includeContext: true,
  });

  const params = useMemo(() => {
    const baseParams: Record<string, unknown> = {
      metricId: props.metricId,
      metricType: [MetricTypeEnum.total],
    };
    if (props.locationIds && props.locationIds.length > 0) {
      baseParams.locationIds = props.locationIds;
    }
    return baseParams;
  }, [props.metricId, props.locationIds]);

  const { data, error, isFetching } = useFetchData<MetricData>({
    endpoint: Endpoints.METRICS_SINGLE,
    params,
    options: {
      enabled: cacheReady && !precacheFetching,
      keepPreviousData: true,
      retry: 3,
    },
    includeContext: true,
  });

  const config: IUseWidgetByType = {
    metricData: data?.content,
    metricId: props.metricId,
    previous: props.previous,
    animate: true,
    type: props.type,
    isLoading: isFetching,
    error: error ? true : false,
    hasLocationFilter: props.hasLocationFilter,
  };

  const childWidget = useWidgetByType(config);

  return <>{childWidget}</>;
};

export default MetricWidget;
